import { ApolloLink } from '@apollo/client';

export const authorizationLink = new ApolloLink((operation, forward) => {
  return forward(operation);
});
